<template>
  <b-row>
    <div class="col-12">
      <h6 class="heading-small text-muted mb-4">Your Invites</h6>
      <b-list-group flush>
        <div v-for="inv in invites" :key="inv.accountInviteId">
          <user-pending-invites-item :invite="inv" class="flex-column align-items-start" :show-countdown="false"></user-pending-invites-item>
        </div>
      </b-list-group>
    </div>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex';
import UserPendingInvitesItem from '#/ui/Components/User/UserPendingInvitesItem.vue';

export default {
  name: 'OnboardInvites',
  components: { UserPendingInvitesItem },
  computed: {
    ...mapGetters('user', {
      invites: 'invites',
    }),
  },
};
</script>

<style scoped>

</style>
